import React, { useState } from 'react';
import RubriqueSelect from './RubriqueSelect';

// Boutons d'action HITL sous une réponse du chat.
// - kind:'execute' → exécution DÉTERMINISTE (le payload est rejoué via /invoke, sans LLM).
// - kind:'dismiss' → action locale (masquer les boutons : « Modifier » / « Annuler »).
// Props : items, busyId (id en cours d'exécution), onAction(item), rubriques [{slug,label}].
//
// Sélecteur de rubrique : si `rubriques` est non vide (site avec rubriques configurées),
// on affiche un menu déroulant et on GATE les boutons execute (« Mettre en ligne » /
// « Brouillon ») tant qu'aucune rubrique n'est choisie — l'humain choisit, l'IA n'invente
// plus. La rubrique choisie part dans onAction(item.rubrique) → POST /actions/execute.
export default function ActionButtons({ items, busyId, onAction, rubriques = [] }) {
  const [selectedRubrique, setSelectedRubrique] = useState('');

  if (!items || items.length === 0) return null;

  const needsRubrique = Array.isArray(rubriques) && rubriques.length > 0;
  const gatedByRubrique = needsRubrique && !selectedRubrique;
  const anyBusy = busyId !== null && busyId !== undefined;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', marginTop: '4px' }}>
      <RubriqueSelect
        rubriques={rubriques}
        value={selectedRubrique}
        onChange={setSelectedRubrique}
        disabled={anyBusy}
      />
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '12px' }}>
        {items.map((item) => {
          const busy = busyId === item.id;
          const isExecute = item.kind === 'execute';
          const disabled = busy || (isExecute && gatedByRubrique);
          const primary = item.style === 'primary';
          const danger = item.style === 'danger';
          return (
            <button
              key={item.id}
              disabled={disabled}
              title={isExecute && gatedByRubrique ? 'Choisis d\'abord une rubrique' : undefined}
              onClick={() => onAction(isExecute ? { ...item, rubrique: selectedRubrique } : item)}
              style={{
                padding: '8px 14px',
                borderRadius: '10px',
                fontSize: '13px',
                fontWeight: 600,
                cursor: disabled ? (busy ? 'default' : 'not-allowed') : 'pointer',
                border: danger ? '1px solid rgba(220,38,38,0.45)'
                  : primary ? 'none' : '1px solid var(--card-border)',
                background: danger ? 'rgba(220,38,38,0.10)'
                  : primary ? '#1D4ED8' : 'var(--card-bg)',
                color: danger ? '#dc2626'
                  : primary ? '#fff' : 'var(--text-secondary)',
                opacity: disabled ? 0.5 : 1,
                transition: 'all 0.15s',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                boxShadow: primary && !disabled ? '0 2px 10px rgba(29,78,216,0.35)' : 'none',
              }}
            >
              {busy ? '…' : item.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
